/**
 * @description LYN-422 Overview utilization read client for TowTech SO chrome.
 *
 * @dependencies apiClient, sendableCompanyId
 *
 * @notes Session company is X-Company-Id from apiClient. All fans out with a
 *   per-request header — query companyId is never sent. Windows only.
 *   Read-only. No jobs write. Residual readers: none.
 */

import apiClient from './apiClient';
import { isSendableCompanyId } from '../../utils/sendableCompanyId';

/**
 * @param {unknown} [companyId]
 * @returns {object|undefined}
 */
function readConfig(companyId) {
  if (!isSendableCompanyId(companyId)) return undefined;
  return { headers: { 'X-Company-Id': companyId } };
}

/**
 * @param {{ companyId?: string }} [params]
 * @returns {Promise<object>}
 */
export function getOverviewUtilization(params = {}) {
  const config = readConfig(params.companyId);
  return (config
    ? apiClient.get('/so/overview-utilization', config)
    : apiClient.get('/so/overview-utilization'))
    .then((response) => response.data);
}

const overviewUtilizationService = { getOverviewUtilization };

export default overviewUtilizationService;
